exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dvidsvideo-container{height:100%;width:100%;background:#000}.dvidsvideo-container .video-overlay{top:50%;left:50%;position:absolute;pointer-events:none}.dvidsPlayer{max-height:inherit !important}.DvidsVideo{height:100%;display:flex;align-items:center;justify-content:center;padding-bottom:0}", ""]);

